import { NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import { sections } from '../config/navigationConfig'
import { SocialLinks } from '../shared/SocialLinks'
import { useTheme } from '../../../contexts/ThemeContext'

export const DesktopNav = () => {
  const { isDark } = useTheme()

  return (
    <div className="hidden md:flex items-center gap-1">
      {Object.entries(sections).map(([key, { title, path }]) => (
        <NavLink
          key={key}
          to={path}
          className={({ isActive }) => `
            relative px-3 py-1.5 rounded-md text-sm transition-colors duration-150
            ${isActive 
              ? isDark 
                ? 'text-accent-400' 
                : 'text-accent-600'
              : isDark
                ? 'text-neutral-400 hover:text-neutral-200'
                : 'text-neutral-600 hover:text-neutral-900'
            }
          `}
        >
          {({ isActive }) => (
            <>
              {title}
              {isActive && (
                <motion.div
                  className="absolute bottom-0 left-1 right-1 h-0.5 bg-accent-500 rounded-full"
                  layoutId="nav-underline"
                  transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                />
              )}
            </>
          )}
        </NavLink>
      ))}
      <div className="ml-2 pl-2 border-l border-neutral-200 dark:border-neutral-800">
        <SocialLinks />
      </div>
    </div>
  )
}